import type { Dayjs } from 'dayjs'

import type { ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { useIsClientAiSubscriptionEnabled } from '@/src/domains/growthbook/hooks/useIsClientAiSubscriptionEnabled'

import { ClientBookingSubscriptionStatusLegacy } from './ClientBookingSubscriptionStatusLegacy'
import { ClientBookingSubscriptionStatusRedesigned } from './ClientBookingSubscriptionStatusRedesigned'

export interface ClientBookingSubscriptionStatusProps {
  month: Dayjs
  therapist: TherapistType
  service: ServiceType
}

export const ClientBookingSubscriptionStatus = (props: ClientBookingSubscriptionStatusProps) => {
  const isClientAiSubscriptionEnabled = useIsClientAiSubscriptionEnabled()

  return isClientAiSubscriptionEnabled ? (
    <ClientBookingSubscriptionStatusRedesigned {...props} />
  ) : (
    <ClientBookingSubscriptionStatusLegacy {...props} />
  )
}
